import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../Router/LanguageContext";

export default function TestimonialSection() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const [pageSize, setPageSize] = useState(2);
  const { dictionary } = useLanguage();

  const testimonials = [
    {
      name: dictionary?.testimonial1Name,
      role: dictionary?.testimonial1Name,
      image: "/assets/img/profile.jpg",
      quote: dictionary?.testimonial1Quote,
    },
    {
      name: dictionary?.testimonial2Name,
      role: dictionary?.testimonial2Role,
      image: "/assets/img/profile.jpg",
      quote: dictionary?.testimonial2Quote,
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setPageSize(window.innerWidth < 768 ? 1 : 2);
    };

    handleResize(); // run initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const next = () => {
    setDirection(1);
    setIndex((prev) =>
      prev + pageSize >= testimonials.length ? 0 : prev + pageSize,
    );
  };

  const prev = () => {
    setDirection(-1);
    setIndex((prev) =>
      prev - pageSize < 0 ? testimonials.length - pageSize : prev - pageSize,
    );
  };

  const visibleItems = testimonials.slice(index, index + pageSize);

  return (
    <div className="container-fluid maxContainerSection commonPadding">
      <div className="row">
        {/* LEFT */}
        <div className="col-md-4 trustedExecutionOuter">
          <div className="trustedExecutionLeftSection">
            <h2 className="m-0 f-s-48">{dictionary?.testimonialTitle}</h2>
            <p className="m-0 f-s-20">{dictionary?.testimonialDesc}</p>
          </div>

          {/* <div className="trustedBtn trustedBtnDesktop">
            <div className="trustedleftbtn" onClick={prev}>
              <img src="/assets/img/arrowLeft.svg" alt="" />
            </div>
            <div className="trustedrightbtn" onClick={next}>
              <img src="/assets/img/arrowRight.svg" alt="" />
            </div>
          </div> */}
        </div>

        {/* RIGHT */}
        <div className="col-md-8 TrustedSectionList">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              className="row"
              initial={{ opacity: 0, x: direction * 80 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: direction * -80 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              {visibleItems.map((item, i) => (
                <div key={i} className="col-md-6 col-sm-12">
                  <div className="ts-card">
                    {/* QUOTE ICON */}
                    <div>
                      <div style={{ display: "flex", gap: 8 }}>
                        <svg width="29" height="30">
                          <path d="M0 30V0H28.5L0 30Z" fill="#0076CB" />
                        </svg>
                        <svg width="29" height="30">
                          <path d="M0 30V0H28.5L0 30Z" fill="#0076CB" />
                        </svg>
                      </div>

                      {/* HEADER */}
                      <div className="ts-card-header">
                        <img src={item.image} alt={item.name} />
                        <div>
                          <h6 className="m-0 f-s-24">{item.name}</h6>
                          <p className="m-0 f-s-16">{item.role}</p>
                        </div>
                      </div>

                      <div className="borderClass" />

                      {/* QUOTE */}
                      <p className="m-0 ts-quote f-s-18">"{item.quote}"</p>
                    </div>
                    {/* GREEN CORNER */}
                    <div className="greenCornerIcon">
                      <svg width="86" height="89">
                        <path
                          d="M86 0L0 89H70C78.8 89 86 81.8 86 73V0Z"
                          fill="#00CE80"
                        />
                      </svg>
                      <svg width="86" height="89">
                        <path
                          d="M86 0L0 89H70C78.8 89 86 81.8 86 73V0Z"
                          fill="#00CE80"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </motion.div>
          </AnimatePresence>

          <div className="trustedBtn trustedBtnMobile">
            <div className="trustedleftbtn" onClick={prev}>
              <img src="/assets/img/arrowLeft.svg" alt="" />
            </div>
            <div className="trustedrightbtn" onClick={next}>
              <img src="/assets/img/arrowRight.svg" alt="" />
            </div>
          </div>
        </div>

        {/* <div className="mobileView">
          <div className="ts-nav ">
            <button className="ts-btn" onClick={prev}>
              ←
            </button>
            <button className="ts-btn active" onClick={next}>
              →
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
}
